<template>
  <div class="slide">
    <ul class="pgwSlider">
      <li v-for="item in sliderList">
        <a :href="item.link">
          <img :src="item.image" :alt="item.title">
          <span>{{ item.title }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: "Slide",
    props:{
      slideData: Array //slideData là tên biến dùng để lưu trữ dữ liệu đặt ở component cha. Kiểu dữ liệu là mảng. Truyền sang component con để dùng
    },
    data(){
      return{
        sliderList: [
          {
            "title": "Liveshow Ấm tình vùng lũ",
            "src": "https://i.ytimg.com/vi/Qdbxw5qj3ck/maxresdefault.jpg"
          },
          {
            "title": "Đừng yêu đậm sâu",
            "src": "https://i.ytimg.com/vi/1c4jx2uqwH8/maxresdefault.jpg"
          },
          {
            "title": "Bước qua thế giới",
            "src": "https://i.ytimg.com/vi/EoQYOF5P-14/maxresdefault.jpg"
          },
          {
            "title": "Hãy nói với em",
            "src": "https://www.vnmedia.vn/file/8a10a0d36ccebc89016ce0c6fa3e1b83/old_image/201804/original/images2143018_anh1.jpg"
          }
        ]
      }
    },
    mounted (){
      /*setTimeout( () => {
        $('.pgwSlider').pgwSlider({
          maxHeight: "400"
        });
      }, 500 );*/
    },
    methods: {
      getListSlide(){
        axios.post(api.slide, {pageSize: 4})
          .then(response => {
            this.sliderList = response.data.result;
            return 1;
          })
          .then(response => {
            $('.pgwSlider').pgwSlider({
              maxHeight: "400"
            });
          })
          .catch(e => {
            console.log("Slide----");
            console.log(e);
          });
      }
    },
    watch: {
      "$route.path": {
        handler: "getListSlide",
        immediate: true
      }
    }
  }
</script>

<style scoped>
  .slide{
    display: inline-table;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/web/Slide.vue